import React, { useState } from 'react';
import { DentosLanding } from './pages/DentosLanding';
import { KnowledgeBasePage } from './pages/KnowledgeBasePage';
import { ToolsPage } from './pages/ToolsPage';
import { ResearchPage } from './pages/ResearchPage';
import { DentalKidsPage } from './pages/DentalKidsPage';
import { LogoShowcasePage } from './pages/LogoShowcasePage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo'>('home');
  return <>
      {currentPage === 'home' ? <DentosLanding onNavigate={setCurrentPage} data-id="element-0" /> : currentPage === 'knowledge' ? <KnowledgeBasePage onNavigate={setCurrentPage} data-id="element-1" /> : currentPage === 'tools' ? <ToolsPage onNavigate={setCurrentPage} data-id="element-2" /> : currentPage === 'research' ? <ResearchPage onNavigate={setCurrentPage} data-id="element-3" /> : currentPage === 'dental-kids' ? <DentalKidsPage onNavigate={setCurrentPage} data-id="element-4" /> : <LogoShowcasePage onNavigate={setCurrentPage} data-id="element-5" />}
    </>;
}